import React from 'react';
import { Input, Button } from '@storaensods/seeds-react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Form from '../shared/components/Form/Form';
import Flex from '../shared/components/Flex/Flex';

const validationSchema = yup.object({
  originId: yup
    .string()
    .required(),
  destinationId: yup
    .string()
    .required(),
  carrierId: yup
    .string()
    .required(),
});

const initialValues = {
  originId: '',
  destinationId: '',
  carrierId: '',
};

export default function TrackingExcludeForm({ data, onSubmit }) {
  const {
    values, handleChange, handleSubmit, errors, submitForm, isSubmitting,
  } = useFormik({
    initialValues: data || initialValues,
    onSubmit,
    validationSchema,
  });

  return (
    <Form onSubmit={handleSubmit}>
      <Input
        style={{ marginBottom: 8 }}
        label="Pick Up Location ID"
        id="originId"
        size="sm"
        value={values.originId}
        onChange={handleChange}
        helpText={errors && errors.originId}
        invalid={errors && !!errors.originId}
      />
      <Input
        style={{ marginBottom: 8 }}
        label="Drop Off Location ID"
        id="destinationId"
        size="sm"
        value={values.destinationId}
        onChange={handleChange}
        helpText={errors && errors.destinationId}
        invalid={errors && !!errors.destinationId}
      />
      <Input
        style={{ marginBottom: 8 }}
        label="Carrier ID"
        id="carrierId"
        size="sm"
        value={values.carrierId}
        onChange={handleChange}
        helpText={errors && errors.carrierId}
        invalid={errors && !!errors.carrierId}
      />
      <Flex style={{ flexDirection: 'row-reverse' }}>
        <Button onClick={submitForm} disabled={isSubmitting}>
          { data ? 'Update' : 'Save'}
        </Button>
      </Flex>
    </Form>
  );
}
